import { render, staticRenderFns } from "./activeAction.vue?vue&type=template&id=08fd2cd7&"
import script from "./activeAction.vue?vue&type=script&lang=js&"
export * from "./activeAction.vue?vue&type=script&lang=js&"
import style0 from "./activeAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports